import React, { useState, useEffect } from 'react'
import { Row, Col, Spin, Pagination, Radio } from 'antd';
import SingleNft from '../../Components/Nft/SingleNft';
import BackButton from '../../Components/Nft/BackButton'
import axios from 'axios'
import './NftListing.css'

function NftListing() {

    const [nftList, setNftList] = useState([])
    const [isNFTDataLoading, setIsNFTDataLoading] = useState(false)
    const PAGE_SIZE = 20
    const [currentPage, setCurrentPage] = useState(1)
    const [totalSize, setTotalSize] = useState(0)
    const [paginatedNFTList, setPaginatedNFTList] = useState([])
    const [rarity, setRarity] = useState('all')

    useEffect(() => {
        fetchNFTListFromAPI()
    }, [])

    const onPageChange = (page) => {
        setCurrentPage(page)
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    const onRarityChange = (e) => {
        setRarity(e.target.value)
    }

    useEffect(() => {
        if (nftList && nftList.length > 0) {

            if (rarity === 'all') {
                const paginatedList = nftList.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)
                setTotalSize(nftList.length)
                setPaginatedNFTList(paginatedList)
            } else {

                const filteredNFTList = nftList.filter(item => {
                    return item.type === rarity
                })
                setTotalSize(filteredNFTList.length)
                const paginatedList = filteredNFTList.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)
                setPaginatedNFTList(paginatedList)
            }
        } else {
            setTotalSize(0)
            setPaginatedNFTList([])
        }

    }, [currentPage, nftList, rarity])

    const fetchNFTListFromAPI = async () => {
        try {
            setIsNFTDataLoading(true)
            const endpoint = 'https://h4g.mypinata.cloud/ipfs/QmZ4YWijATu8d7ViHpR51j6tpHjmDiaavj73BK79DN2Avc/_metadata.json'
            const response = await axios.get(endpoint)
            if (response.status === 200) {
                const nftData = response.data
                if (nftData && nftData.length > 0) {
                    setTotalSize(nftData.length)
                    setNftList(nftData)
                } else {
                    setTotalSize(nftData.length)
                    setNftList([])
                }
            } else {
                setNftList([])
            }
            setIsNFTDataLoading(false)
        } catch (error) {
            console.error("ERROR : while fetching NFT data from the API ", error)
            setNftList([])
            setIsNFTDataLoading(false)
        }
    }

    return (
        <div className="container">
            <Row className='mt-5'>
                <BackButton />
            </Row>

            <Row className='mt-5'>
                <div className='rarity-selector'>
                    <Radio.Group value={rarity} onChange={onRarityChange} style={{ marginBottom: 16 }}>
                        <Radio.Button value="all">All</Radio.Button>
                        <Radio.Button value="normal">Normal</Radio.Button>
                        <Radio.Button value="rare">Rare</Radio.Button>
                        <Radio.Button value="epic">Epic</Radio.Button>
                    </Radio.Group>
                </div>
            </Row>

            <Row className='mt-3'>

                {
                    isNFTDataLoading ? (
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <div className='d-flex justify-content-center'>
                                <Spin size='large' />
                            </div>
                        </Col>
                    ) : (
                        <>

                            {
                                paginatedNFTList.map((item, index) => (
                                    <Col xs={24} sm={24} md={6} lg={6} xl={6} key={index}>
                                        <SingleNft data={item} />
                                    </Col>
                                ))
                            }


                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <div className='d-flex justify-content-center'>
                                    <Pagination
                                        defaultCurrent={1}
                                        pageSize={PAGE_SIZE}
                                        total={totalSize}
                                        onChange={onPageChange}
                                    />
                                </div>
                            </Col>
                        </>


                    )
                }


            </Row>

        </div>
    )
}

export default NftListing